exports.categoryParams = {
  urlPrefix: "/categoria-producto/",
};

exports.createCategories = async ({ graphql, actions }) => {
  const { createPage, createRedirect } = actions;
  const result = await graphql(
    `
      {
        categories: allStrapiCategory {
          edges {
            node {
              slug
              updated_at
              strapiParent {
                slug
              }
              strapiId
            }
          }
        }
      }
    `
  );

  if (result.errors) {
    throw result.errors;
  }

  const categories = result.data.categories.edges;
  const CategoryTemplate = require.resolve("./src/templates/category.js");
  const CategoryColorTemplate = require.resolve("./src/templates/category-color.js");


  categories.forEach((category, index) => {
    const categoryPath = `${this.categoryParams.urlPrefix}${category.node.slug}`;

    if (category.node.strapiParent && category.node.strapiParent.slug === "tote-bags-par-couleur")
      createPage({
        path: categoryPath,
        component: CategoryColorTemplate,
        context: {
          ...category.node,
        },
      });
    else
      createPage({
        path: categoryPath,
        component: CategoryTemplate,
        context: {
          ...category.node,
        },
      });


    const fromPath = `${category.node.slug}`;
    createRedirect({
      fromPath,
      toPath: categoryPath,
      isPermanent: true,
      redirectInBrowser: true,
      force: true,
    });
    // redirect /[cat] to /categoria-producto/[cat]
    if (category.node.slug === "bolsos-yute") {
      console.log("============== Redirecting /bolsos-yute to /categoria-producto/bolsos-yute ==============");
      console.log(fromPath, categoryPath);
    }
    
  });

};
